// extracted by mini-css-extract-plugin
export default {"product-price":"product-price--Oapmt","productPrice":"product-price--Oapmt"};